<template>
  <div class="done">
    <div class="confetti" aria-hidden="true">
      <i v-for="p in pieces" :key="p.id" :style="p.style"></i>
    </div>

    <div class="done__icon"><span class="mdi mdi-check"></span></div>
    <h2 class="done__title">¡Tu parque está listo!</h2>
    <p class="done__text">{{ text }}</p>

    <ul class="chips">
      <li v-for="(c, i) in chips" :key="c" class="chip" :style="{ animationDelay: `${0.5 + i * 0.1}s` }">✓ {{ c }}</li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { ob, savedPlots } from '@/services/onboardingStore'

const chips = computed(() => {
  const out = ['Parque configurado']
  const n = savedPlots().length
  if (n) out.push(`${n} ${n === 1 ? 'nave registrada' : 'naves registradas'}`)
  if (ob.contractsImported > 0) out.push(`${ob.contractsImported} ${ob.contractsImported === 1 ? 'contrato importado' : 'contratos importados'}`)
  else if (ob.contractCreated) out.push('Primer contrato activo')
  return out
})

const text = computed(() =>
  ob.contractCreated || ob.contractsImported > 0
    ? 'Hemos configurado todo lo necesario para comenzar a operar. Tu primer cargo de renta se generará automáticamente el día configurado.'
    : 'Hemos configurado lo necesario para comenzar a operar. Puedes seguir agregando naves, inquilinos y contratos desde el panel.',
)

// Confeti discreto (azul, verde, blanco). Posiciones y tiempos fijos por pieza para que no cambien al re-renderizar.
const COLORS = ['#3b82f6', '#10b981', '#ffffff', '#60a5fa']
const pieces = Array.from({ length: 36 }, (_, i) => ({
  id: i,
  style: {
    left: `${(i * 37) % 100}%`,
    background: COLORS[i % COLORS.length],
    animationDelay: `${((i * 53) % 18) / 10}s`,
    animationDuration: `${2.6 + ((i * 29) % 14) / 10}s`,
    width: `${5 + (i % 3) * 2}px`,
    height: `${8 + (i % 4) * 2}px`,
    opacity: 0.85,
  },
}))
</script>

<style scoped>
.done { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 24px; text-align: center; color: #fff; overflow: hidden; }
.confetti i { position: absolute; top: -20px; border-radius: 2px; animation: fall linear infinite; }
.done__icon { width: 96px; height: 96px; border-radius: 50%; background: rgba(16, 185, 129, 0.15); display: flex; align-items: center; justify-content: center; margin-bottom: 22px; animation: pop 0.4s ease-out both; }
.done__icon .mdi { font-size: 64px; color: #10b981; line-height: 1; }
.done__title { margin: 0; font: 700 28px var(--font-display); animation: rise 0.4s 0.3s both; }
.done__text { margin: 12px 0 0; max-width: 400px; font: 400 14px/1.6 var(--font-body); color: rgba(255, 255, 255, 0.8); animation: rise 0.4s 0.4s both; }
.chips { list-style: none; margin: 26px 0 0; padding: 0; display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; }
.chip { padding: 6px 14px; border-radius: 20px; background: rgba(16, 185, 129, 0.15); color: #86efac; font: 400 12px var(--font-body); animation: rise 0.3s both; }

@keyframes pop { 0% { transform: scale(0); } 70% { transform: scale(1.2); } 100% { transform: scale(1); } }
@keyframes rise { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
@keyframes fall { to { transform: translateY(110vh) rotate(540deg); } }

@media (prefers-reduced-motion: reduce) {
  .confetti { display: none; }
  .done__icon, .done__title, .done__text, .chip { animation-duration: 0.01ms; animation-delay: 0s; }
}
</style>